module.exports = __webpack_public_path__ + "static/media/email.2adcf886.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/email.svg
// module id = 5368
// module chunks = 1